/* eslint-disable no-useless-computed-key */
import { Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import ButtonCom from '../../../components/button/ButtonCom';
import InputControl from '../../../components/input/InputControl';
import Card from '../../../components/layout/Card';
import TransitionsModal from '../../../components/modal/Modal';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import { colors, fonts } from '../../../utils';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllFaqs } from '../../../redux/slices/shareholderRights/shareholderRights';
import { errorNotify, successNotify } from '../../../utils/helper';
// import Table from '../../../components/table/Table';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useNavigate } from 'react-router-dom';
import Editor from 'react-simple-wysiwyg';
import ReadMoreReact from "read-more-react";
import DeleteModal from '../../../components/deletemodal/DeleteModal';

const styles = {
	tableHeading: {
		fontSize: '1.3rem',
		fontWeight: '700',
		fontFamily: 'poppins, sans-serif',
	},
	tableRows: {
		fontSize: '1.3rem',
		fontFamily: 'poppins, sans-serif',
	},


};

const Faq = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { faqs } = useSelector((state) => state?.shareholderRights);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [modalName, setModalName] = useState("");
	const [sortedData, setSortedData] = useState([]);
	const fileInputRef = useRef(null);
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		question: '',
		answer: '',
		type: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});


	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false)
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getFaqs = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(`${endPoints?.shareHolderRights?.fetchFaqs}`, {

				"status": "true", //all/true/false
				"type": "shareholder", //home/sharehlder
				"limit": limit || 50,
				"page": page || 1,
				user_id:  clientId == 0 ? null : userId

			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllFaqs(
							response?.data?.data?.faqs?.faqs?.map((d, index) => ({
								id: d?.id,
								question: d?.question,
								answer: d?.answer,
								dt: d?.dt,
								type: d?.type,
								creator_id: d?.creator_id,
								is_enabled: d?.is_enabled,
								creator_name: d?.creator_name,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.faqs?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
					console.log(error)
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			console.log(err)
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleDeleteFaq = async () => {

		try {

			await Api.post(endPoints?.shareHolderRights?.deleteFaqs, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Faq Deleted Successfully")
					handleCloseDeleteModal();
					getFaqs();

				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}
	};
	const handleCreateFaqModal = () => {
		setFormData({ question: '', answer: '', type: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditFaqModal = (val) => {
		setFormData({ question: val.question, answer: val.answer, type: val.type, creator_id: val.creator_id, id: val.id, is_enabled: val.is_enabled })
		setOpenModal(true)
		setIsEditing(true);
	};


	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		setFormData({ question: '', answer: '', type: '' })
		setOpenDeleteModal(false)
	};

	const handleSubmit = async () => {
		setIsLoadingModal(true)
		if (!isEditing) {


			try {

				await Api.post(endPoints?.shareHolderRights?.createFaqs, {
					...formData,
					type: "shareholder",
					creator_id: 1,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getFaqs();
						successNotify("Faq Created Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (error) {
				errorNotify(error?.response?.data?.message
					? error?.response.data.message
					: "something went wrong");
			}

		} else {


			try {

				await Api.post(endPoints?.shareHolderRights?.updateFaqs, {
					...formData,
					type: "shareholder",
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getFaqs();
						successNotify("Faq Updated Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (error) {
				errorNotify(error?.response?.data?.message
					? error?.response.data.message
					: "something went wrong");
			}
		}
	};

	useEffect(() => {
		getFaqs();
	}, [])


	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Question',
			field: 'question',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.question?.length > 15 ?
					<ReadMoreReact
						text={rowData?.question}
						min={10}
						ideal={15}
						max={rowData?.question?.length}
						readMoreText="Read More"
					/> : rowData?.question}</h4>,
		},
		{
			title: 'Answer',
			field: 'answer',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.answer?.length > 15 ?
					<ReadMoreReact
						text={rowData?.answer}
						min={10}
						ideal={15}
						max={rowData?.answer?.length}
						readMoreText="Read More"
					/> : rowData?.answer}
			</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditFaqModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Delete',
			field: 'delete',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Delete'>
					<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			),
		},

	];

	const typesList = [{
		id: "home",
		description: "Home"
	}, {
		id: "shareholder",
		description: "Shareholder"
	}]

	const [rows, setRows] = useState([]);
	useEffect(() => {
		if (faqs) {
			setRows(faqs)
		}
	}, [faqs])
	const onDragEnd = (result) => {
		if (!result.destination) return;

		const updatedRows = Array.from(rows);
		const [movedRow] = updatedRows.splice(result.source.index, 1);
		updatedRows.splice(result.destination.index, 0, movedRow);

		const updatedRowsWithSort = updatedRows.map((row, index) => ({
			...row,
			sort: index + 1
		}));

		setRows(updatedRowsWithSort);

		setSortedData(updatedRowsWithSort);
	};

	const handleSortSubmit = async () => {
		await Api.post(endPoints?.shareHolderRights?.updateFaqs, { faqs: sortedData }, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				handleCloseModal();
				getFaqs();
				successNotify("Faqs Sorting Updated Successfully")
				setIsLoadingModal(false)
			})
			.catch((error) => {

			});
	}

	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='space-between' gap='1rem' mb='2rem' fw='wrap'>
					<h1>Faqs</h1>
					<ButtonCom onClickHandler={handleCreateFaqModal} btnTitle={"Create"} />
				</Flex>
				{/* {sliders?.map((val) => {
					return <>

						<Box style={styles.box}>
							<Box>
								<Typography className='font-face-R' variant="h3">{val.name}</Typography>
								<Typography className='font-face-R' variant="body1">{val.description}</Typography>
							</Box>
							
							<Box>
							<Box>
								<Button onClick={() => handleEditFaqModal(val)}  ><EditIcon fontSize='large' /></Button>
								<Button onClick={() => handleOpenDeleteModal(val)}  ><DeleteIcon fontSize='large' color='error'/></Button>
							</Box>
								<ButtonCom onClickHandler={()=>navigate(`/slides/${val.id}`, { state: val })} btnTitle={"View Slides"} />
							</Box>

						</Box>
					</>
				})} */}

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Faq" : "Create Faq"}
						isLoading={isLoadingModal}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.question}
									onChange={handleChange}
									label='Question'
									name='question'
									required
								/>
							</MarginHandler>
							{/* <MarginHandler width='100%'>
								<InputControl
									state={formData?.answer}
									onChange={handleChange}
									label='Answer'
									name='answer'
									multiline
									rows={2}
								/>
							</MarginHandler> */}

							<label>
								Answer
							</label>
							<Editor value={formData?.answer} name='answer' onChange={handleChange} />

							{/* <MarginHandler>
								<FilledSelectOption
									label='Type *'
									state={formData?.type}
									onChange={(e) => {
										setFormData({ ...formData, type: e.target.value });
									}}
									options={typesList}
									width='18rem'
									name='type'
								/>
							</MarginHandler> */}

							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.question || !formData.answer}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>


				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDeleteFaq}
				/>



				{/* {isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={faqs?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Faq's"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getFaqs(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getFaqs(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				} */}
				<DragDropContext onDragEnd={onDragEnd}>
					<Droppable droppableId="droppable" direction="vertical">
						{(provided) => (
							<TableContainer
								component={Paper}
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell style={styles.tableHeading}>Id</TableCell>
											<TableCell style={styles.tableHeading}>Question</TableCell>
											<TableCell style={styles.tableHeading}>Answer</TableCell>
											<TableCell style={styles.tableHeading}>Date</TableCell>
											<TableCell style={styles.tableHeading}>Edit</TableCell>
											<TableCell style={styles.tableHeading}>Delete</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{rows.map((row, index) => (
											<Draggable key={row.id} draggableId={row.id} index={index}>
												{(provided) => (
													<TableRow
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
													>
														<TableCell style={styles.tableRows}>{row?.id}</TableCell>
														<TableCell style={styles.tableRows}>{row?.question?.length > 15 ?
															<ReadMoreReact
																text={row?.question}
																min={10}
																ideal={15}
																max={row?.question?.length}
																readMoreText="Read More"
															/> : row?.question}</TableCell>
														<TableCell style={styles.tableRows}>
															<td dangerouslySetInnerHTML={{ __html: row?.answer?.substring(0, 50) + "..." }} />
															{/* {row?.answer?.length > 15 ?
															<ReadMoreReact
																text={row?.answer}
																min={10}
																ideal={15}
																max={row?.answer?.length}
																readMoreText="Read More"
															/> : row?.answer} */}
														</TableCell>
														<TableCell style={styles.tableRows}>{moment(row?.dt).format("DD-MM-YYYY")}</TableCell>
														<TableCell style={styles.tableRows}><Tooltip title='Edit'>
															<IconButton onClick={() => handleEditFaqModal(row)} aria-label='Edit'>
																<EditIcon />
															</IconButton>
														</Tooltip></TableCell>
														<TableCell style={styles.tableRows}><Tooltip title='Delete'>
															<IconButton onClick={() => handleOpenDeleteModal(row)} aria-label='Delete'>
																<DeleteIcon />
															</IconButton>
														</Tooltip></TableCell>
													</TableRow>
												)}
											</Draggable>
										))}
									</TableBody>
								</Table>
								{provided.placeholder}
							</TableContainer>
						)}
					</Droppable>
				</DragDropContext>

				<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1em" }}>
					<ButtonCom onClickHandler={handleSortSubmit} btnTitle={"Save Sorting"} />
				</div>



			</Card>
		</>
	);
};

export default Faq;
